import DOMPurify from 'dompurify';

// Force links that survive sanitization to open safely.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('rel', 'noopener noreferrer');
    if (node.getAttribute('target') === null) {
      node.setAttribute('target', '_blank');
    }
  }
});

/**
 * Sanitize note/document HTML before rendering with dangerouslySetInnerHTML.
 * Keeps all normal formatting (bold, lists, links, images, styles) and strips
 * anything executable (scripts, event handlers, javascript: URLs).
 */
export const sanitizeHtml = (html: string): string => {
  if (!html) return '';
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
};

/**
 * Sanitizer for the visualization tooltips, which render entry content plus
 * generated tag pills. Matches the old regex filter's intent (div/span only,
 * inline styles preserved) without letting event-handler attributes through.
 */
export const sanitizeTooltipHtml = (html: string): string => {
  if (!html) return '';
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['div', 'span', 'br'],
    ALLOWED_ATTR: ['style'],
  });
};

/**
 * Extract plain text from an HTML string without executing anything.
 * Safe replacement for the `tempDiv.innerHTML = html` pattern: even in a
 * detached element, an unsanitized <img onerror=...> would fire.
 */
export const htmlToText = (html: string): string => {
  if (!html) return '';
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = sanitizeHtml(html);
  return tempDiv.textContent || tempDiv.innerText || '';
};
